<template>
  <section>
    <v-dialog
      v-model="dialog"
      width="800px">
      <div class="dialog-container">
        <div class="dialog-header">
          <h2>New Claim Ticket</h2>
          <div class="btn-container">
            <v-button
              size="small"
              @click="dialog = false">Cancel</v-button>
            <v-button
              size="small"
              type="primary"
              @click="handlerCreate">Create</v-button>
          </div>
        </div>
        <el-form
          ref="form"
          :model="formData"
          :rules="rules">
          <div class="dialog-content flex">
            <div class="left">
              <div class="form-item">
                <span>Assignee</span>
                <el-form-item prop="assignee_id">
                  <v-select
                    v-model="formData.assignee_id"
                    :disabled="!!form.assignee_id"
                    :list="globalOptions.assignee" />
                </el-form-item>
              </div>
              <div
                v-if="!isFina&&!isEnquiry"
                class="form-item">
                <span>Customer</span>
                <el-form-item
                >
                  <el-select
                    v-if="!!form.customer_id"
                    v-model="customerName"
                    disabled
                    size="small"
                  >
                    <el-option
                      :label="customerName"
                      :value="customerName"></el-option>
                  </el-select>
                  <v-select
                    v-else
                    v-model="formData.customer_id"
                    :list="customerOptions"
                    nameGroup
                    :disabled="!!form.customer_id||customerOptions.length<=0"
                    :clearable="true" />
                </el-form-item>
              </div>
            </div>
            <div class="right">
              <div class="form-item">
                <span>Accident Date</span>
                <el-form-item prop="accident_date">
                  <v-date-picker v-model="formData.accident_date" />
                </el-form-item>
              </div>
              <template v-if="isMotor">
                <div class="form-item">
                  <span class="pd-b-0 ">Accident Driver Name</span>
                  <span class="fs-12 color-gray">Must be the same as HKID</span>
                  <div class="flex mg-t-3">
                    <div class="mg-r-8">
                      <el-form-item
                        ref="isrd_lst_nm"
                        prop="isrd_lst_nm">
                        <v-input
                          v-model="formData.isrd_lst_nm"
                          placeholder="Last Name"
                          uppercase
                        />
                      </el-form-item>
                    </div>
                    <el-form-item
                      ref="isrd_fst_nm"
                      prop="isrd_fst_nm">
                      <v-input
                        v-model="formData.isrd_fst_nm"
                        placeholder="First Name"
                        uppercase
                      />
                    </el-form-item>
                  </div>
                </div>
                <div class="form-item">
                  <span>Accident Driver HKID Number</span>
                  <el-form-item
                    ref="id_no"
                    prop="id_no">
                    <v-input
                      v-model="formData.id_no"
                      uppercase
                      placeholder="A123456(3), please input A1234563"
                    />
                  </el-form-item>
                </div>
              </template>
              <template v-if="isTravelOrPA">
                <div class="form-item">
                  <span class="pd-b-0 ">Accident Insured</span>
                  <span class="fs-12 color-gray ">If there is another person responsible, please file another claim.</span>
                  <el-form-item
                    ref="id_no"
                    :rules="rules.select"
                    prop="id_no">
                    <v-select
                      v-model="formData.id_no"
                      :list="form.list"
                      value-key="id_no"
                      :labelKey="'lst_nm'"
                      show-name
                      :labelSecondKey="'fst_nm'"
                      class="mg-t-3" />
                  </el-form-item>
                </div>
              </template>
              <template v-if="!isMotor&&!isTravelOrPA">
                <div class="form-item">
                  <span>Accident Insured</span>
                  <el-form-item prop="isrd_nm">
                    <v-input
                      v-model="formData.isrd_nm"
                      disabled />
                  </el-form-item>
                </div>
              </template>
              <div class="form-item">
                <span>Contact Person</span>
                <el-form-item prop="contact_person">
                  <v-input
                    v-model="formData.contact_person" />
                </el-form-item>
              </div>

              <div class="form-item">
                <span>Contact Number</span>
                <el-form-item prop="contact_no">
                  <v-input
                    v-model="formData.contact_no" />
                </el-form-item>
              </div>
              <div class="form-item mg-b-10">
                <span>Brief Description Of The Accident</span>
                <el-form-item prop="description">
                  <v-input
                    v-model="formData.description"
                    type="textarea"
                    :rows="4" />
                </el-form-item>
              </div>
              <span
                v-for="(item, index) in claimFormList"
                :key="index"
                class="font-16 blue pointer block mg-b-10"
                @click="downloadClaimForm(item.url)">{{ item.name }}</span>
              <div class="form-item">
                <span>Documents</span>
                <section v-if="formData.other_file.length > 0">
                  <file-container
                    v-for="(item, index) in formData.other_file"
                    :key="index"
                    :fileData="item"
                    :edit="true"
                    :otherData="{
                      index
                    }"
                    titleName= "Documents"
                    @uploadSuccess="handlerUploadSuccess"
                    @delete="deleteOtherFile">
                    <!-- document{{ index+1 }} -->
                  </file-container>
                </section>
                <v-upload
                  @uploadSuccess="handlerUploadSuccess" />
              </div>
            </div>
          </div>
        </el-form>
      </div>
    </v-dialog>
    <select-send-message
      ref="auto-renew-email-sms"
      v-model="showAutoCloseSelectMessage"
      :form="detailData"
      :initSmsContent="auto_renew_close_data"
      :init-email-content="email_auto_renew_close_data"
      :init-share-content="share_auto_renew_close_data"
      :init-refer-content="auto_renew_close_data"
      :is-only-referrer="isFina"
      :updateContent="true"
      @send="handlerRenewSend"
      @skip="handlerRenewSkip"/>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import FileContainer from '@/views/components/file-container'
import { getClaimForm, createClaimTicket } from '@/api/ticket'
import SelectSendMessage from '@/views/components/dialogs/select-send-message'
export default {
  name: 'NewClaimTicket',
  components: {
    FileContainer,
    SelectSendMessage
  },
  mixins: [MixinOptions, MixinRules],
  props: {
    orderId: {
      type: [String, Number],
      default: ''
    },
    form: {
      type: Object,
      default: () => ({})
    },
    detailData: {
      type: Object,
      default: () => ({})
    },
    customer:{
      type: [Object,Array],
      default: () => ({})
    },
    customerProfile:{
      type: [Object,Array],
      default: () => ({})
    },
    continute: {
      type: Boolean,  // 創建完是否跳轉 ticket 詳情
      default: true
    },
    isEnquiry: {
      type: Boolean,  // 創建完是否跳轉 ticket 詳情
      default: false
    }
  },
  data() {
    return {
      dialog:false,
      showAutoCloseSelectMessage:false,
      // claimFormUrl: '',
      claimFormList: [],
      formData: {
        accident_date: '',
        contact_person: '',
        contact_no: '',
        description: '',
        other_file: [],
        assignee_id: '',
        customer_id: '',
        merchant_platform:'',
        isrd_nm:'',
        id_type:1,
        id_no:'',
        isrd_fst_nm:'',
        isrd_lst_nm:'',
      }
    }
  },
  computed:{
    customerName(){
      let {isrd_nm=''} = this.customer||{}
      return isrd_nm ||''
    },
    isFina(){
      let {merchant_platform} = this.form||{}
      return merchant_platform == 2
    },
    productId(){
      let {product_id} = this.$route.query
      if(this.isEnquiry){
        return  this.form.product_id
      }
      return Number(product_id)
    },
    isMotor(){
      return this.productId == 11
    },
    isTravelOrPA(){
      let {type_of_insured} = this.form||{}
      return type_of_insured==2&&this.productId==18||[14].includes(this.productId)
    },
    isGuestTravel() {
      let {is_guest_order} = this.form || {}
      return is_guest_order==1
    },
    show_auto_reject(){
      let {auto_renewal_info={}} = this.detailData||{}
      let {disable_on,auto_on } =auto_renewal_info||{}
      return !disable_on&&auto_on&&this.productId==11
    },
    auto_renew_close_data(){
      let {auto_renew_close_data} = this.detailData||{}
      return auto_renew_close_data
    },
    email_auto_renew_close_data(){
      let {renew_email_data={}} = this.detailData||{}
      return renew_email_data.auto_renew_close_data||''
    },
    share_auto_renew_close_data(){
      let {share_renew_data={}} = this.detailData||{}
      let {share_auto_renew_close_data} = share_renew_data||{}
      return share_auto_renew_close_data||''
    },
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        this.formData = Object.assign(this.formData, val)
        let cs_name = localStorage.getItem('cs_name')
        let arr = this.globalOptions.assignee||[]
        arr.some(item=>{
          if(item.name==cs_name){
            this.formData.assignee_id = item.id
          }
        })
        let {customer,name,phone} = val||{}
        if(!this.isTravelOrPA&&this.isMotor){

          let {isrd_nm} = customer||{}
          this.formData.isrd_nm = isrd_nm
        }
        if(this.isEnquiry){
          this.formData.contact_person = name
          this.formData.contact_no = phone
        }
      }
    },
    customerName:{
      immediate: true,
      handler(val){
        if(!this.isTravelOrPA&&!this.isMotor){
          this.formData.isrd_nm = val
        }
      }
    },
    orderId: {
      immediate: true,
      handler(val) {
        if(val) {
          this.network().getClaimForm()
        }
      }
    }
  },
  methods: {
    handlerRenewSkip(content,send_type) {
      let params ={}
      params.is_send_sms =0
      params.is_send_email =0
      params.is_share_send =0
      params.content =''
      params.email_content =''
      params.share_content =''
      this.network().createClaimTicket(params)
    },
    handlerRenewSend(data) {
      let params ={}
      let {is_sms_send,content,email_content,share_content,is_share_send,is_email_send} = data ||{}
      params.is_send_sms =is_sms_send
      params.is_send_email =is_email_send
      params.is_share_send =is_share_send
      params.content =content
      params.email_content =email_content
      params.share_content =share_content
      this.network().createClaimTicket(params)
    },
    changeDialog() {
      this.dialog = !this.dialog
    },
    handlerCreate() {
      this.$refs.form.validate(valid => {
        if(valid) {
          if(this.show_auto_reject)
          {
            this.showAutoCloseSelectMessage = true
          }
          else  this.network().createClaimTicket()
        }
      })
    },
    // 上傳完文件
    handlerUploadSuccess({ data, otherData }) {
      const { index = '' } = otherData
      const { name, id } = data
      if(!this.formData.other_file) {
        this.formData.other_file = []
      }
      if(index !== '') {
        this.$set(this.formData.other_file, index, data)
      }
      else {
        this.formData.other_file.push(data)
      }
    },
    deleteOtherFile({ index }) {
      this.formData.other_file.splice(index, 1)
    },
    downloadClaimForm(url) {
      window.open(url, '_blank')
      // if(!this.claimFormUrl) {
      //   await this.network().getClaimForm()
      // }
      // window.open(this.claimFormUrl, '_blank')
    },
    network() {
      return {
        getClaimForm: async () => {
          const { data } = await getClaimForm({
            order_id: this.orderId,
            hideLoading: true
          })
          this.claimFormList = data.claim_form_download
          // this.claimFormUrl = data.download_url
        },
        createClaimTicket: async (param) => {
          if(this.isFina){
            delete this.formData.customer_id
          }
          if(this.isMotor){
            let {isrd_lst_nm,isrd_fst_nm} = this.formData||{}
            this.formData.isrd_nm = `${isrd_lst_nm} ${isrd_fst_nm}`
          }
          if(this.isTravelOrPA){
            let {id_no} = this.formData||{}
            let {list=[]} = this.form
            list.some(item=>{
              if(item.id_no==id_no){
                this.formData.id_type = item.id_type
                this.formData.isrd_nm = `${item.lst_nm} ${item.fst_nm}`
              }
            })
          }
          let params = {}
          if(this.isEnquiry){
            let {id} = this.$route.query
            params.enquiry_id = id
            delete this.formData.id
          }
          const { data } = await createClaimTicket({
            ...this.formData,
            order_id: this.orderId,
            ...params,
            ...param
          })
          this.changeDialog()

          if(this.continute) {
            this.$router.push({
              path: '/tickets/detail',
              query: {
                ticket_id: data.id
              }
            })
          }
          else {
            this.$emit('success')
          }

        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-container {
    padding: 15px;
    color: #616266;
    // h2 {
    //   font-size: 24px;
    // }
    .dialog-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 -15px;
      padding: 0 15px 5px 15px;
      border-bottom: 1px solid #dddfe7;
      h1 {
        font-size: 24px;
      }
    }
    .dialog-content {
      padding-top: 15px;
      & > div {
        flex: 1;
      }
      .left {
        margin-top: -15px;
        padding-right: 15px;
        padding-top: 15px;
        border-right: 1px solid #dddfe7;
      }
      .right {
        padding-left: 15px;
      }
    }
  }
.el-select {
  width: 100%;
  /deep/ .el-input__prefix {
    display: flex;
    align-items: center;
    padding-left: 3px;
    height: 100%;
  }
  .svg-inline--fa {
    font-size: 16px;
  }
  .el-input__suffix-inner{
    i{
      height: 32px;
      line-height: 32px;
    }
  }
}
//.el-select-dropdown__item {
//  height: auto;
//  line-height: auto;
//  .send-info {
//    padding-bottom: 5px;
//    span {
//      display: block;
//      line-height: 15px;
//      font-size: 12px;
//    }
//  }
//}
</style>
